import { QuestionAndAnswers, Report, User } from "./Interfaces";
import { Storage } from "@ionic/storage";

export namespace UtilFunctions {
  export const getLocalStorageObject = async () => {
    const storage = new Storage();
    await storage.create();
    return storage;
  };

  export const formatDateForFile = (date: Date) => {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  export const formatDate = (date: Date) => {
    if (!date) return "";

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getUTCHours();
    const minutes = date.getMinutes();
    const amPM = hours >= 12 ? "PM" : "AM";
    const x = date.toLocaleTimeString("en-GB", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "UTC",
    });

    return `${month} ${day}, ${year} ${x.toUpperCase()}`;
  };

  const getCarWashNameFromReport = (questionAnswersArray: any[]) => {
    let name = "";
    const nameQuestion = questionAnswersArray.find(
      (element: { question: string; answer: string }) =>
        element.question === "What is the name of the car wash?" || element.question === "Name"
    );

    return nameQuestion.answer.trim() ? nameQuestion.answer : "N/A";
  };

  // some reports have the answer field named "anwser" and others have it named "answer" so this gets both into one list
  const fixQuestionAnswersArray = (questionAnswersArray: any[]) => {
    const result: QuestionAndAnswers[] = [];
    questionAnswersArray.forEach(qa => {
      result.push({
        question: qa.question,
        answer: qa.answer ? qa.answer : qa.anwser,
      });
    });
    return result;
  };

  const getDetectedAddress = (obj: any) => {
    if (!obj) {
      return null;
    } else {
      const parsedObj = JSON.parse(obj);
      return {
        streetNumber: parsedObj.streetNumber,
        route: parsedObj.route,
        city: parsedObj.city,
        district: parsedObj.district,
        postalCode: parsedObj.postalCode,
        region: parsedObj.region,
        country: parsedObj.country,
      };
    }
  };

  const getManualAddress = (obj: any) => {
    const parsedObj = JSON.parse(obj);
    return {
      streetName: parsedObj.streetName ? parsedObj.streetName : parsedObj.StreetName ? parsedObj.StreetName : "",
      postcode: parsedObj.posctCode ? parsedObj.posctCode : parsedObj.Postcode ? parsedObj.Postcode : "",
      town: parsedObj.town ? parsedObj.town : parsedObj.Town ? parsedObj.Town : "",
    };
  };

  // map reports from json data to my own Report type
  export const mapReports = (reports: any[]) => {
    const newReportArray: Report[] = [];
    reports.forEach(rep => {
      const questionAnswersArray = JSON.parse(rep.questionAndAnswers);
      if (questionAnswersArray === null) return; // skip the few reports that have a value of null for questionAndAnswers

      const name = getCarWashNameFromReport(questionAnswersArray);
      // const date = formatDateForGrid(new Date(rep.dateTimeCreated));

      const questionAnswersArrayFixed = fixQuestionAnswersArray(JSON.parse(rep.questionAndAnswers));

      newReportArray.push({
        id: rep.id,
        carWashName: name,
        county: rep.County == 0 ? "N/A" : rep.County,
        latitude: rep.latitude,
        longitude: rep.longitude,
        localAuth: rep.LocalAuthorityDistrict == 0 ? "N/A" : rep.LocalAuthorityDistrict,
        test: rep.test,
        policeArea: rep.PoliceForce == 0 ? "N/A" : rep.PoliceForce,
        score: rep.score,
        sentMSH: rep.SentMSH ? "Yes" : "No",
        showMSH: rep.ShowMSH ? "Yes" : "No",
        dateTimeCreated: new Date(rep.dateTimeCreated),
        detectedAddress: getDetectedAddress(rep.detectedAddress),
        manualAddress: getManualAddress(rep.manualAddress),
        questionAndAnswers: questionAnswersArrayFixed,
      });
    });
    return newReportArray;
  };

  export const mapUsers = (users: any[]) => {
    const newUserArray: User[] = [];
    users.forEach(user => {
      newUserArray.push({
        id: user.id,
        fbId: user.FB_UUID,
        email: user.email,
        displayName: user.displayName,
        groups: user.Groups,
        area: user.Area,
        weeklyReports: user.WeeklyReports,
      });
    });
    return newUserArray;
  };
}
